import { Button, Empty, Modal, Tag, Typography } from 'antd';
import { CheckCircleFilled, GiftOutlined } from '@ant-design/icons';
import type { PosGiftVariantOption } from '../types';
import { formatVND } from '@/utils/format';

const { Text } = Typography;

interface GiftVariantPickerDialogProps {
  open: boolean;
  onClose: () => void;
  productName: string;
  /** Số lượng quà cần tặng theo cấu hình voucher — variant tồn ít hơn bị disable. */
  requiredQty: number;
  options: PosGiftVariantOption[];
  selectedVariantId?: string;
  onSelect: (option: PosGiftVariantOption) => void;
}

/**
 * TCR-1074: modal chọn variant quà tặng khi voucher free_gift trỏ tới 1
 * product có nhiều variant — caller (`VoucherModal`) đã fetch `options` sẵn
 * (cần list này để quyết định auto-chọn hay mở dialog), nên component này
 * KHÔNG tự fetch (khác `WarehousePickerDialog`).
 */
export function GiftVariantPickerDialog({
  open,
  onClose,
  productName,
  requiredQty,
  options,
  selectedVariantId,
  onSelect,
}: GiftVariantPickerDialogProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <span>
          <GiftOutlined style={{ color: '#a4193d', marginRight: 8 }} />
          Chọn biến thể quà tặng — {productName}
        </span>
      }
      width={480}
      footer={<Button onClick={onClose}>Đóng</Button>}
    >
      {options.length === 0 ? (
        <Empty description="Không có biến thể nào" />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {options.map((o) => {
            const insufficient = !o.is_sellable || o.stock_quantity < requiredQty;
            const isSelected = o.variant_id === selectedVariantId;
            return (
              <button
                key={o.variant_id}
                type="button"
                disabled={insufficient}
                onClick={() => onSelect(o)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px 12px',
                  borderRadius: 6,
                  border: isSelected ? '1px solid #a4193d' : '1px solid #eee',
                  background: '#fff',
                  cursor: insufficient ? 'not-allowed' : 'pointer',
                  opacity: insufficient ? 0.55 : 1,
                  textAlign: 'left',
                }}
              >
                <div>
                  <Text strong>{o.variant_name || o.variant_code}</Text>
                  <div style={{ fontSize: 12, color: '#888' }}>{o.variant_code}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Tag color={insufficient ? 'red' : 'green'}>Tồn: {o.stock_quantity}</Tag>
                  <Text style={{ fontSize: 12, color: '#888' }}>{formatVND(o.unit_price)}</Text>
                  {isSelected && <CheckCircleFilled style={{ color: '#a4193d' }} />}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
